/**
 * Time utility functions for timestamp conversion
 */

export const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Converts a timestamp to Unix milliseconds.
 * Handles both second and millisecond timestamps from Matrix SDK.
 *
 * @param {number} value - Timestamp value (can be in seconds or milliseconds)
 * @returns {number|null} - Unix timestamp in milliseconds, or null if invalid
 */
export const toUnixMilliseconds = (value) => {
  if (typeof value !== 'number' || Number.isNaN(value)) return null;
  // Matrix timestamps are already in milliseconds (13+ digits)
  // If less than 1e12, assume it's in seconds and convert to ms
  return value > 1e12 ? Math.floor(value) : Math.floor(value * 1000);
};
